interface StatCardProps {
  label: string;
  value: string | number;
  hint: string;
}

export function StatCard({ label, value, hint }: StatCardProps): JSX.Element {
  return (
    <article className="stat-card">
      <p className="stat-card__label">{label}</p>
      <strong className="stat-card__value">{value}</strong>
      <p className="stat-card__hint">{hint}</p>
    </article>
  );
}

